import React from 'react'
import {
  Box,
  FormLabel,
  InputAdornment,
  Stack,
  TextField,
  Typography
} from '@mui/material'
import { RoundedButton } from 'common/Button/Button'
import { FormikProps } from 'formik'
import { IDeliveryDetails } from 'types/api/v1/org.type'
interface ContactDetailsProps {
  setNextPage: (value: void) => void
  setPreviousPage: (value: void) => void
  formik: FormikProps<IDeliveryDetails>
}

function DeliveryContactDetails({
  setNextPage,
  setPreviousPage,
  formik
}: ContactDetailsProps) {
  return (
    <>
      <Typography variant='h4'>Contact Details</Typography>
      <Typography variant='subtitle1'>
        Fill the contact person details for item delivery.
      </Typography>
      <Box sx={{ height: '60vh' }}>
        <Box sx={{ display: 'flex', gap: '2vw' }}>
          <Stack sx={{ margin: '24px 8px', width: '40%' }}>
            <FormLabel className='formSectionHeader'>
              Contact Person&apos;s Name
            </FormLabel>
            <TextField
              onChange={(e) => {
                formik.handleBlur(e)
                formik.handleChange(e)
              }}
              variant='standard'
              fullWidth
              placeholder='Enter Name'
              name='contactName'
              value={formik.values.contactName || ''}
              error={
                formik.touched.contactName && Boolean(formik.errors.contactName)
              }
              helperText={
                formik.touched.contactName && formik.errors.contactName
              }
            />
          </Stack>
          <Stack sx={{ margin: '24px 8px', width: '40%' }}>
            <FormLabel className='formSectionHeader'>Contact Number</FormLabel>
            <TextField
              onChange={(e) => {
                formik.handleBlur(e)
                formik.handleChange(e)
              }}
              variant='standard'
              fullWidth
              placeholder='Contact Number'
              name='contactNum'
              value={formik.values.contactNum || ''}
              error={
                formik.touched.contactNum && Boolean(formik.errors.contactNum)
              }
              helperText={formik.touched.contactNum && formik.errors.contactNum}
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>+65</InputAdornment>
                )
              }}
            />
          </Stack>
        </Box>
        <Box sx={{ display: 'flex', gap: '2vw' }}>
          <Stack sx={{ margin: '24px 8px', width: '40%' }}>
            <FormLabel className='formSectionHeader'>Email</FormLabel>
            <TextField
              onChange={(e) => {
                formik.handleBlur(e)
                formik.handleChange(e)
              }}
              variant='standard'
              fullWidth
              placeholder='Enter Email'
              name='email'
              value={formik.values.email || ''}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
            />
          </Stack>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <RoundedButton variant='secondary' onClick={() => setPreviousPage()}>
          Back
        </RoundedButton>
        <RoundedButton variant='filled' onClick={() => setNextPage()}>
          Next
        </RoundedButton>
      </Box>
    </>
  )
}

export default DeliveryContactDetails
